// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addAllWishListLines as addAllWishListLinesApi } from "@bg/App/Services/WishListService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    CallAddAllWishListLinesApi,
    chain,
} from "@insite/client-framework/Store/Pages/MyLists/Handlers/AddAllWishListLines";

export const XngCallAddAllWishListLinesApi: any = async (props: any) => {
    await addAllWishListLinesApi(props.parameter.apiParameter);
    props.apiResult = { error: false };
};

replaceInChain(chain, CallAddAllWishListLinesApi, XngCallAddAllWishListLinesApi);
